import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { GraphQLRequestProps, request } from '@repo/ui/src/utils/graphql-request';
import { gql } from 'graphql-request';
import useSWR from 'swr';

interface AutocompleteResponse {
  listPopularSearchTerms: {
    hits: Array<{
      query: string;
    }>;
  };
}
const document = gql`
  query ListPopularSearchTerms($query: String, $pageSize: Int, $page: Int) {
    listPopularSearchTerms(query: $query, pageSize: $pageSize, page: $page) {
      hits {
        query
      }
    }
  }
`;

const fetcher = async (props: GraphQLRequestProps<{ query: string }>) => {
  if (!props.variables?.query) {
    return null;
  }
  const data = await request<AutocompleteResponse>(props);
  return data!.listPopularSearchTerms;
};

export const useAutocomplete = (searchTerm: string) => {
  const { locale } = useCurrentUrl();
  return useSWR(
    {
      document,
      variables: { query: searchTerm },
      locale,
    },
    fetcher,
    { keepPreviousData: true },
  );
};
